import React from 'react';
import { MenuIcon, HelpCircleIcon, WifiOffIcon } from './icons';
import { UserRole } from '../App';
import RoleSwitcher from './RoleSwitcher';
import ProjectSwitcher from './ProjectSwitcher';
import { Project } from '../types';
import Logo from './Logo';

interface HeaderProps {
  userRole: UserRole;
  setUserRole: (role: UserRole) => void;
  isSidebarOpen: boolean;
  setIsSidebarOpen: (isOpen: boolean) => void;
  projects: Project[];
  currentProject: Project | null;
  setCurrentProjectId: (id: string) => void;
  onOpenCreateProject: () => void;
  onStartTour: () => void;
  actualUserRole?: UserRole;
  isOnline?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  userRole,
  setUserRole,
  setIsSidebarOpen,
  projects,
  currentProject,
  setCurrentProjectId,
  onOpenCreateProject,
  onStartTour,
  actualUserRole,
  isOnline = true,
}) => {

  return (
    <header className={`flex-shrink-0 bg-white border-b border-app-border px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-6 relative z-40`}>
      <div className="flex items-center gap-4 min-w-0 flex-1">
        {(userRole === 'researcher' || userRole === 'orgadmin') && actualUserRole !== 'superadmin' && (
          <div className="flex items-center gap-2">
            <button onClick={() => setIsSidebarOpen(true)} className="text-action lg:hidden active:scale-90 transition-transform p-2 rounded-full hover:bg-white">
              <MenuIcon className="w-7 h-7" />
            </button>
            {!isOnline && (
              <div className="hidden sm:flex items-center gap-1.5 px-2.5 py-1 bg-status-warn-bg text-status-warn rounded-full text-xs font-medium border border-status-warn">
                <WifiOffIcon className="w-3.5 h-3.5" />
                <span>Offline Mode</span>
              </div>
            )}
            <ProjectSwitcher
              projects={projects}
              currentProject={currentProject}
              setCurrentProjectId={setCurrentProjectId}
              onOpenCreateModal={onOpenCreateProject}
            />
          </div>
        )}
        {userRole === 'participant' && (
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <Logo className="w-10 h-10 transition-transform" />
              {!isOnline && (
                <div className="flex items-center gap-1.5 px-2.5 py-1 bg-status-warn-bg/50 text-status-warn rounded-full text-xs font-medium border border-status-warn/50 ml-2">
                  <WifiOffIcon className="w-3.5 h-3.5" />
                  <span className="hidden sm:inline">Offline</span>
                </div>
              )}
            </div>
            <h1 className="text-2xl font-bold text-text-ink tracking-tight hidden sm:block">Dekko</h1>
          </div>
        )}
      </div>
      <div className="flex items-center gap-4">
        {/* Show RoleSwitcher ONLY if the actual user is a researcher */}
        {(actualUserRole === 'researcher' || actualUserRole === 'orgadmin') && (
          <RoleSwitcher userRole={userRole} setUserRole={setUserRole} />
        )}
        {(userRole === 'researcher' || userRole === 'orgadmin') && (
          <button onClick={onStartTour} className="text-text-muted hover:text-text-ink p-1.5 rounded-md hover:bg-app-bg transition-colors">
            <HelpCircleIcon className="w-6 h-6" />
          </button>
        )}
      </div>
    </header>
  );
};

export default Header;